<template>
  <div class="container-center-horizontal">
    <div class="prices-1920 screen">
      <div class="overlap-group6">
        <img class="rectangle-21" :src="rectangle21" alt="Rectangle 21" />
        <div class="rectangle-11"></div>
        <left-nav />
        <info v-bind="globalData" />
      </div>
      <div class="flex-row">
        <h1 class="algt-report-price-list plusjakartasans-bold-mine-shaft-48px">{{ algtReportPriceList }}</h1>
        <div class="overlap-group2">
          <img
            class="vector-1"
            src="img/vector-9.svg"
            alt="Vector"
          />
          <div class="fee-pdf heebo-bold-white-24px">
            <a :href="globalData.algtReportPriceListPdf" target="_blank" style="visited: {text-align:center; color:#fff;}">
            {{ feePdf }}
          </a>
        </div>
        </div>
      </div>
      
      <!-- Price Table Section -->
      <div class="price-table-section">
        <PriceTable :priceData="priceListData" viewSize="large" />
      </div>

      <group46 :algtReportPriceListPdf="globalData.algtReportPriceListPdf"/>
      <foot v-bind="globalData" />
    </div>
  </div>
</template>

<script>
import LeftNav from "./components/Navbar";
import Foot from "./components/Foot1920";
import Info from "./components/Info";
import Group46 from "./price/Group46";
import PriceTable from "../components/PriceTable";
import priceListData from "../price-list-2025";

export default {
  name: "Price1920",
  components: {
    LeftNav,
    Foot,
    Info,
    Group46,
    PriceTable,
  },
  data() {
    return {
      priceListData,
    };
  },
  props: [
    "globalData",
    "rectangle21",
    "algtReportPriceList",
    "feePdf",
  ],
};
</script>

<style lang="sass" scoped>
@import '../../variables'

.prices-1920
  align-items: center
  background-color: $selago-2
  display: flex
  flex-direction: column
  overflow: hidden
  position: relative
  width: 1920px

.overlap-group6
  align-self: flex-start
  height: 400px
  position: relative
  width: 2000px

.rectangle-21
  height: 400px
  left: 0
  object-fit: cover
  position: absolute
  top: 0
  width: 1920px

.rectangle-11
  background-color: $black-3
  height: 400px
  left: 0
  position: absolute
  top: 0
  width: 1920px

.flex-row
  align-items: flex-start
  display: flex
  gap: 458px
  margin-left: 2.0px
  margin-top: 58px
  min-width: 1402px

.algt-report-price-list
  letter-spacing: 0
  line-height: normal
  margin-top: 1px
  min-height: 60px
  min-width: 579px

.overlap-group2
  align-items: center
  background-color: $brand
  border-radius: 4px
  display: flex
  gap: 12px
  height: 64px
  min-width: 363px
  padding: 12px 30px

.vector-1
  height: 24px
  margin-bottom: 4.0px
  width: 18px

.fee-pdf
  align-self: flex-end
  letter-spacing: 0
  line-height: 38.4px
  min-width: 273px
  white-space: nowrap

.price-table-section
  width: 100%
  max-width: 1400px
  margin: 40px auto

</style>
